export default "__VITE_ASSET__DTZlz5jE__"